import UploadHttpLink from "apollo-upload-client/UploadHttpLink.mjs";

import { BASE_URL } from "@/constants";
import { IS_ME_LINK, LANDING_URL } from "@/constants/app";

export const uploadLink = new UploadHttpLink({
  uri: `${IS_ME_LINK ? LANDING_URL : BASE_URL}/graphql/`,
  credentials: "include",
});
